import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { CLIENT_DATE_FORMAT } from '@app/const/AppSetting';
import {
	findObjInArr,
	formatCurencyVI,
	formatDateServer,
	isEmpty,
	isNull
} from '@app/utils/CommonFunctions';
import 'react-datepicker/dist/react-datepicker.css';
import './formInput.scss';
import MyReactDatePicker from "@app/utils/MyReactDatePicker";

const FormInput = (props) => {
	const [error, setError] = useState(false);
	const {
		cssClass,
		errorMessage,
		id,
		label,
		onChange,
		options,
		type,
		...inputProps
	} = props;
	const [notInputDot, setNotInputDot] = useState(false);
	const [input, setInput] = useState();

	useEffect(() => {
		setError(!isEmpty(errorMessage));
	}, [errorMessage]);

	useEffect(() => {
		const isError = !isEmpty(errorMessage);
		setError(isError);
		if (!isEmpty(type)) {
			if (type === 'date')
				setInput(
					<MyReactDatePicker

						isV2
						id={inputProps.name}
						name={inputProps.name}

						onDayChange={handleChange}
						value={inputProps.value}
					/>

				);
			else if (type === 'multi-select')
				setInput(
					<Select
						classNamePrefix={`react-select${isError ? '-red' : ''}`}
						name={inputProps.name}
						options={options}
						value={inputProps?.value}
						isClearable
						//isDisabled={!isEmpty(inputProps.readOnly) && inputProps.readOnly}
						onChange={handleChange}
						isMulti={true}
					/>,
				);
			else if (type === 'select')
				setInput(
					<Select
						classNamePrefix={`react-select${isError ? '-red' : ''}`}
						name={inputProps.name}
						options={options}
						value={findObjInArr(options, inputProps?.value)}
						isClearable
						isDisabled={!isEmpty(inputProps.readOnly) && inputProps.readOnly}
						onChange={handleChange}
					/>,
				);
			else if (type === 'select-text')
				setInput(
					<CreatableSelect
						classNamePrefix={`react-select${isError ? '-red' : ''}`}
						name={inputProps.name}
						options={options}
						value={findObjInArr(options, inputProps.value)}
						isClearable
						isDisabled={!isEmpty(inputProps.readOnly) && inputProps.readOnly}
						onChange={handleChange}
						onCreateOption={handleCreateOption}
					/>,
				);
			else {
				let isNaN = formatCurencyVI(inputProps.value);
				let numVal = '';
				if (inputProps.value === '-') numVal = '-';
				if (type === 'number' && isNaN !== '' && numVal !== '-' && !isEmpty(inputProps.value))
					numVal = `${formatCurencyVI(inputProps.value)}${
						inputProps.value.toString().lastIndexOf('.') > 0 &&
						inputProps.value.toString().lastIndexOf('.') === inputProps.value.length - 1
							? ','
							: ''
					}`;
				setInput(
					<input
						className={`form-control form-control-border form-control-sm ${
							type === 'number' ? 'text-right' : ''
						}`}
						{...inputProps}
						value={type === 'number' ? numVal : inputProps.value}
						onChange={handleChange}
						onKeyPress={handleKeyPress}
						error={isError.toString()}
					/>,
				);
			}
		}
	}, [type, options, inputProps.value, errorMessage]);

	const handleChange = (e) => {

		if(type.includes('multi-select'))
		{
			console.log('multi-select');
			console.log(e);
		}


		let value = '';
		if(type.includes('multi-select'))
			value = [];
		/*if (type === 'date') value = formatDateServer(e);
		else*/
		 if (type ==='multi-select') value = e ? e.value : [];
		else if (type.includes('select')) value = e ? e.value : '';
		else value = e.target.value;
		if (type === 'number') {
			value = isNull(value, '0');
			if (value.lastIndexOf('.') === value.length - 1)
				value = `${value.substring(0, value.length - 1)},`;
			let numArr = [];
			let check = notInputDot;
			if (!value.includes(',') || value.lastIndexOf('.') !== value.length - 1) {
				check = false;
				setNotInputDot(false);
			}
			if (check) {
				if (value.includes(',')) numArr = value.split(',');
				else if (value.split('.').length > 2) {
					numArr[0] = value.substring(0, value.lastIndexOf('.'));
					numArr[1] = value.substring(value.lastIndexOf('.') + 1, value.length);
				} else setNotInputDot(false);
			}
			value =
				numArr.length > 0
					? `${numArr[0].replace(/\./g, '')}.${numArr[1]}`
					: value.replace(/\./g, '').replace(/,/, '.');
		}
		onChange(inputProps.name, value);
		setError(false);
	};

	const handleCreateOption = (e) => {
		options.push({ label: e, value: e });
		onChange(inputProps.name, e);
		setError(false);
	};

	const handleKeyPress = (e) => {
		if (type === 'number') {
			let check = notInputDot;
			const value = e.target.value;
			if (value.includes(',')) {
				check = true;
				setNotInputDot(true);
			}
			if (e.key === '.' || e.key === ',') {
				if (check) e.preventDefault();
				else setNotInputDot(true);
			}
			const keyCode = [44, 45, 46];
			if ((e.charCode < 48 && !keyCode.includes(e.charCode)) || e.charCode > 57)
				e.preventDefault();
		}
	};

	return (
		<div key={`form-input-${inputProps.name}`}
			className={`formInput col d-flex flex-column ${
				cssClass ? cssClass : 'mb-3'
			}`}>
			{label && <label className="mb-0">{label}</label>}
			{input}
			<span error={error.toString()}>{errorMessage}</span>
		</div>
	);
};

export default FormInput;
